<template>
  <div class="home">
    <!-- Hero Section -->
    <b-carousel
      v-if="config && config.images && config.images.dash && config.images.dash.length > 0"
      id="carousel-hero"
      :interval="5000"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;">
      <b-carousel-slide
        v-for="(image, index) in config.images.dash"
        :key="index"
        :img-src="image">
      </b-carousel-slide>
    </b-carousel>
    
    <!-- Welcome Section -->
    <b-container class="my-5">
      <b-row>
        <b-col class="text-center">
          <h1 class="display-4">Bienvenido a {{ shopName }}</h1>
          <p class="lead">{{ config && config.welcome_text ? config.welcome_text : 'Tu tienda online de confianza' }}</p>
        </b-col>
      </b-row>
    </b-container>

    <!-- Featured Products -->
    <b-container v-if="featuredProducts.length > 0" class="my-5">
      <h2 class="text-center mb-4">Productos Destacados</h2>
      <b-row>
        <b-col 
          v-for="product in featuredProducts" 
          :key="product.id"
          cols="12" 
          sm="6" 
          md="4" 
          lg="3"
          class="mb-4">
          <product-card :product="product" />
        </b-col>
      </b-row>
    </b-container>

    <!-- Categories Section -->
    <b-container class="my-5">
      <h2 class="text-center mb-4">Categorías</h2>
      <b-row>
        <b-col 
          v-for="category in mainCategories" 
          :key="category.id"
          cols="6" 
          md="4" 
          lg="3"
          class="mb-4">
          <b-card 
            @click="goToCategory(category)"
            class="category-card text-center h-100"
            body-class="d-flex flex-column justify-content-center">
            <b-icon 
              icon="collection" 
              font-scale="3" 
              variant="primary"
              class="mb-3">
            </b-icon>
            <h5>{{ category.name }}</h5>
            <small class="text-muted">{{ category.products_count || 0 }} productos</small>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <!-- Call to Action -->
    <section class="cta-section bg-primary text-white py-5">
      <b-container>
        <b-row class="align-items-center">
          <b-col md="8">
            <h3>¿Buscas algo específico?</h3>
            <p class="mb-0">Explora nuestro catálogo completo de productos</p>
          </b-col>
          <b-col md="4" class="text-md-right">
            <b-button 
              variant="light" 
              size="lg"
              :to="{ name: 'Products' }">
              Ver Todos los Productos
              <b-icon icon="arrow-right" class="ml-2"></b-icon>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue'

export default {
  name: 'HomePage',
  components: {
    ProductCard
  },
  data() {
    return {
      shopName: 'ESCALITY Shop'
    }
  },
  computed: {
    config() {
      return this.$store.getters.shopConfig
    },
    featuredProducts() {
      return this.$store.state.featuredProducts.slice(0, 8)
    },
    mainCategories() {
      return this.$store.state.categories.filter(cat => !cat.parent_id).slice(0, 8)
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      await Promise.all([
        this.$store.dispatch('loadFeaturedProducts'),
        this.$store.dispatch('loadCategories')
      ])
    },
    goToCategory(category) {
      this.$router.push({ 
        name: 'Products', 
        query: { category: category.id }
      })
    }
  }
}
</script>

<style scoped>
.category-card {
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.cta-section {
  background: linear-gradient(135deg, #2563EB 0%, #10B981 100%);
}
</style>